import Vue from 'vue'
import { Tooltip } from 'ant-design-vue'
import _ from 'lodash'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
      <div :class="{ 'cell-ellipsis': ellipsis }">
        <a-tooltip placement="right" :title="title"> {{value}} </a-tooltip>
      </div>
      `,
  data: function() {
    return {
      value: undefined,
      title: undefined,
      // LPA-9: single-line "…" overflow; autoHeight columns keep wrapping
      ellipsis: true,
    }
  },
  beforeMount() {
    this.ellipsis = !_.get(this.params, 'colDef.autoHeight', false)
    const name = this.params.colDef.cellRendererParams
      ? this.params.colDef.cellRendererParams.name
      : ''
    if (this.params.colDef.field === 'quantity') {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      const value = _.get(this.params, 'value', null)
      if (value) {
        this.value = new Intl.NumberFormat(settings.currency.currencyFormate, {
          currency: settings.currency.currency,
        }).format(value)
        this.title = this.value
      } else {
        this.value = _.get(this.params, 'value', null)
        this.title = _.get(this.params, 'value', null)
      }
    } else {
      switch (name) {
        case 'id':
          this.value = this.params.data.id ? this.params.data.id : ''
          this.title = this.params.data.id ? this.params.data.id : ''
          break
        case 'asset_Number':
          this.value = this.params.data.asset_Number
          this.title = this.value =
            this.params.data.asset_Number && this.params.data.asset_Description
              ? this.params.data.asset_Number +
                ' - ' +
                this.params.data.asset_Description
              : this.params.data.asset_Number
          break
        case 'asset_Description':
          this.value =
            this.params.data.asset_Number && this.params.data.asset_Description
              ? this.params.data.asset_Number +
                ' - ' +
                this.params.data.asset_Description
              : this.params.data.asset_Number
          this.title = this.value =
            this.params.data.asset_Number && this.params.data.asset_Description
              ? this.params.data.asset_Number +
                ' - ' +
                this.params.data.asset_Description
              : this.params.data.asset_Number
          break
        case 'contract':
          this.value =
            this.params.data.contract || this.params.data.contract === 0
              ? parseFloat(this.params.data.contract)
              : null
          this.title =
            (this.params.data.contract || this.params.data.contract === 0) &&
            this.params.data.contractName
              ? this.params.data.contract +
                ' - ' +
                this.params.data.contractName
              : this.params.data.contract
          break
        case 'contractName':
          this.value =
            (this.params.data.contract || this.params.data.contract === 0) &&
            this.params.data.contractName
              ? parseFloat(this.params.data.contract) +
                ' - ' +
                this.params.data.contractName
              : this.params.data.contract
          this.title =
            (this.params.data.contract || this.params.data.contract === 0) &&
            this.params.data.contractName
              ? parseFloat(this.params.data.contract) +
                ' - ' +
                this.params.data.contractName
              : this.params.data.contract
          break
        case 'categoryCode':
          this.value = this.params.data.categoryCode
          this.title =
            this.params.data.categoryCode &&
            this.params.data.categoryCodeDescription
              ? this.params.data.categoryCode +
                ' - ' +
                this.params.data.categoryCodeDescription
              : this.params.data.categoryCode
          break
        case 'categoryCodeDescription':
          this.value =
            this.params.data.categoryCode &&
            this.params.data.categoryCodeDescription
              ? this.params.data.categoryCode +
                ' - ' +
                this.params.data.categoryCodeDescription
              : this.params.data.categoryCode
          this.title =
            this.params.data.categoryCode &&
            this.params.data.categoryCodeDescription
              ? this.params.data.categoryCode +
                ' - ' +
                this.params.data.categoryCodeDescription
              : this.params.data.categoryCode
          break
        case 'assetClass':
          this.value = this.params.data.assetClass
          this.title = this.params.data.assetClass
          break
        case 'multiplier':
          this.value = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(3)
            : 1
          this.title = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(3)
            : 1
          break
        case 'varianceFactor':
          this.value = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(2)
            : 1
          this.title = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(2)
            : 1
          break
        case 'calculation':
          this.value = _.get(this.params, 'value', null)
          this.title = _.get(this.params.data, 'formula', null)
          break
        case 'constructionQualityFactor':
          this.value = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(2)
            : this.params.value
          this.title = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(2)
            : this.params.value
          break
        case 'conditionFactor':
          this.value = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(2)
            : this.params.value
          this.title = _.get(this.params, 'value', null)
            ? parseFloat(_.get(this.params, 'value', null)).toFixed(2)
            : this.params.value
          break
        default:
          this.value = _.get(this.params, 'value', null)
          this.title = _.get(this.params, 'value', null)
          break
      }
    }
  },
})
